import {
  Security,
  SupervisorAccount,
  Engineering,
  Support,
  Build,
  LocalShipping,
  AdminPanelSettings,
  ManageAccounts,
  Settings,
  Shield
} from '@mui/icons-material';

export const AVAILABLE_ICONS = [
  { value: 'Security', label: 'Безпека', Icon: Security },
  { value: 'SupervisorAccount', label: 'Менеджер', Icon: SupervisorAccount },
  { value: 'Engineering', label: 'Інженер', Icon: Engineering },
  { value: 'Support', label: 'Підтримка', Icon: Support },
  { value: 'Build', label: 'Технік', Icon: Build },
  { value: 'LocalShipping', label: 'Водій', Icon: LocalShipping },
  { value: 'AdminPanelSettings', label: 'Адміністратор', Icon: AdminPanelSettings },
  { value: 'ManageAccounts', label: 'Керування', Icon: ManageAccounts },
  { value: 'Settings', label: 'Налаштування', Icon: Settings },
  { value: 'Shield', label: 'Захист', Icon: Shield }
];

const iconMap: { [key: string]: any } = {
  Security,
  SupervisorAccount,
  Engineering,
  Support,
  Build,
  LocalShipping,
  AdminPanelSettings,
  ManageAccounts,
  Settings,
  Shield
};

export const getRoleIcon = (iconName?: string) => {
  if (!iconName || !iconMap[iconName]) {
    return Security;
  }
  return iconMap[iconName];
};
